import { NgModule } from '@angular/core';

import { BakeriesApiService } from './services/bakeries-api.service';
import { ProductsApiService } from './services/products-api.service';
import { OrdersApiService } from './services/orders-api.service';
import { CitiesApiService } from './services/cities-api.service';
import { DeliveryApiService } from './services/delivery-api.service';
import { UserApiService } from './services/user-api.service';
import { GiftCardsApiService } from './services/gift-cards-api.service';

import { CategoriesManagerService } from './managers/categories-manager.service';
import { OrdersManagerService } from './managers/orders-manager.service';

@NgModule({
  providers: [
    BakeriesApiService,
    ProductsApiService,
    OrdersApiService,
    CitiesApiService,
    DeliveryApiService,
    UserApiService,
    GiftCardsApiService,

    CategoriesManagerService,
    OrdersManagerService
  ]
})
export class ApiServicesModule {
}
